"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = exports.StyledContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 8px;

  .content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-left: 12px;
    max-height: 300px;
  }

  .footer {
    display: flex;
    justify-content: space-between;
  }
`;
exports.StyledSearchInput = (0, styled_components_1.default)(material_1.OutlinedInput) `
  background-color: ${ui_components_1.baseColors.white};
`;
